export default __webpack_public_path__ + "static/media/aboute.832fd22d.jpg";